import React, { useState, useEffect } from 'react';
import { Link, location, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import Nav from './Nav';
import Language from './Language';
import UserProfile from './UserProfile';
import HelpCenter from './HelpCenter';
import Logout from './Logout';

import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';

import { BoxFlexStartCenter } from '../../components/customComponent/box';

import * as basicConstants from '../../constants/basic';
import { PAGE_DATA } from '../../constants/url';

import { baseUrl } from '../../api/api';

import logo from '../../Logo.svg';
import { MenuOutlinedIcon, LogoutOutlinedIcon } from '../../constants/images';


const Topbar = (props) => {
  const { userData, currentMedia, setCurrentMedia } = props;
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const [menuOpen, setMenuOpen] = useState(false);
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = useColorSystem();
  const { entryPath, setEntryPath, setIsModalOpen } = useGlobalStatus();

  const toggleDrawer = (newOpen) => () => {
    setMenuOpen(newOpen);
  };

  const showLanguage = Object.values(PAGE_DATA).some(
    (page) => pathname === page.path && page.language
  );

  return (
    <>
      {
        isDesktop &&
        <Box pt={6} >
          <AppBar
            id="appbar"
            position="fixed"
            sx={{
              zIndex: 1000,
              boxShadow: 'none',
              boxShadow: '0px 2px 16px rgba(107, 117, 128, 0.25)',
              backgroundColor: mainColor,
              paddingRight: { xl: 10, lg: 10, md: 0 }
            }}
          >
            <Toolbar
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                minHeight: { xs: '56px' }
              }}
            >
              <BoxFlexStartCenter>
                {/* <MenuOutlinedIcon
                  onClick={toggleDrawer(!menuOpen)}
                  sx={{
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                /> */}

                <Box onClick={() => setIsModalOpen(false)}>
                  <Link to="/" style={{ display: 'block', width: '100%' }}>
                    <img src={logo} alt={basicConstants.PRODUCT_NAME} style={{ width: '180px' }} />
                  </Link>
                </Box>
                {baseUrl.showVersion &&
                  <ListItem
                    sx={{
                      width: 'auto',
                      color: '#FFF',
                      padding: '5px 10px',
                      ml: '30px',
                      border: '1px solid #fff',
                      borderRadius: '30px',
                      fontSize: '0.875rem'
                    }}
                  >
                    {baseUrl.versionName}
                  </ListItem>}
              </BoxFlexStartCenter>

              <Box sx={{ display: 'flex' }}>
                <HelpCenter />
                {showLanguage && <Language />}
                <UserProfile
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                  color={mainColor}
                />
              </Box>
            </Toolbar>
          </AppBar>

          <Drawer
            variant="permanent"
            // onClose={toggleDrawer(false)}
            anchor="left"
            // open={menuOpen}
            // PaperProps={{
            //   sx: { width: '22%' },
            // }}
            sx={{
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: '220px',
                zIndex: 900,
                boxSizing: 'border-box',
                boxShadow: '0px 0px 16px rgba(107, 117, 128, 0.15)'
              }
            }}
          >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }} >
              <Box>
                <Nav
                  userData={userData}
                  toggleDrawer={toggleDrawer(false)}
                  isDesktop={isDesktop}
                  isMobile={isMobile}
                />
              </Box>
            </Box>
          </Drawer>

        </Box>
      }
      {
        isMobile &&
        <Box pt={10}>
          <AppBar
            id="appbar"
            position="fixed"
            sx={{
              zIndex: 1000,
              boxShadow: 'none',
              backgroundColor: mainColor,
            }}
          >
            <Toolbar sx={{ minHeight: '64px' }} >
              <Box
                sx={{
                  position: 'absolute',
                  left: '16px',
                }}
              >
                <MenuOutlinedIcon
                  onClick={toggleDrawer(!menuOpen)}
                  sx={{ color: '#fff' }}
                />
              </Box>

              <Box sx={{ mx: 'auto' }}>
                <Link to="/" style={{ display: 'block', width: '100%' }}>
                  <img src={logo} alt={basicConstants.PRODUCT_NAME} style={{ width: '180px' }} />
                </Link>
              </Box>
            </Toolbar>
          </AppBar>

          <Drawer
            onClose={toggleDrawer(false)}
            anchor="left"
            open={menuOpen}
            sx={{
              [`& .MuiDrawer-paper`]: {
                minWidth: '35%',
              }
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100vh',
                padding: '32px 16px 0',
                boxSizing: 'border-box'
              }}
            >
              <Box>
                <Box mb={2}>
                  <UserProfile
                    userData={userData}
                    isDesktop={isDesktop}
                    isMobile={isMobile}
                  />
                </Box>

                <Nav
                  userData={userData}
                  toggleDrawer={toggleDrawer(false)}
                  isDesktop={isDesktop}
                  isMobile={isMobile}
                />
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  margin: '0 -16px',
                  padding: '8px',
                  borderTop: `1px solid ${theme.palette.grey.w200}`
                }}
              >
                <HelpCenter />
                <Logout variant="icon" />
              </Box>

            </Box>
          </Drawer>
        </Box>
      }
    </>
  )
}

export default Topbar;